import { Typography } from '@jouzen/ecom-components/v3/Typography';
import { useTranslations } from 'next-intl';

import P from '../P';

const IpIntro = () => {
  const t = useTranslations();
  return (
    <>
      <Typography Element="h1" variant="h1" className="mb-16 pb-8">
        {t('ip_notice_title')}
      </Typography>

      <P tx="ip_notice_intro" />
    </>
  );
};

export default IpIntro;
